import React, { useState, useContext } from "react";
import { Modal } from "antd";
import Card from "../../components/Card/Card";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import TitleBanner from "../../components/TitleBanner/TitleBanner";
import Payment from "../Payment/Payment";
import { AppContext } from "../../context";
import OrderDetails from "../Payment/OrderDetails";

function Reservations({
  confirmedProducts,
  pendingProducts,
  updateList,
  setUpdateList,
  setActiveKey,
}) {
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const info = useContext(AppContext);

  return (
    <div>
      {confirmedProducts.length > 0 && (
        <>
          <TitleBanner
            title={info.t("confirmedReservations")}
            // subtitle={info.t("reservationsArePayable")}
          >
            <button
              className="ahp-button ahp-xl"
              type="button"
              onClick={() => setShowOrderDetails(true)}
              style={{
                margin: "1.7rem 1.5rem 1.7rem 1.5rem",
                padding: "10px 40px 10px 40px",
              }}
            >
              {info.t("pay")}
            </button>
          </TitleBanner>

          {showOrderDetails && (
            <OrderDetails
              confirmedProducts={confirmedProducts}
              closeOrderDetails={() => setShowOrderDetails(false)}
            />
          )}

          <CardGridWrapper>
            {confirmedProducts?.map((product, index) => (
              // <ReservationCard store={r} key={index}></ReservationCard>
              <Card
                entity={product.type}
                product={product}
                key={"confirmed" + index}
                updateList={updateList}
                reserveBtn={false}
                messagesBtn={true}
                setUpdateList={setUpdateList}
                context="reservation"
              />
            ))}
          </CardGridWrapper>
        </>
      )}
      {pendingProducts.length > 0 && (
        <>
          <TitleBanner
            title={info.t("awaitingConfirmation")}
            subtitle={info.t("willReceiveInfo")}
          />

          <CardGridWrapper>
            {pendingProducts.length > 0 &&
              pendingProducts?.map((product, index) => (
                // <ReservationCard store={r} key={index}></ReservationCard>
                <Card
                  entity={product.type}
                  product={product}
                  key={"pending" + index}
                  updateList={updateList}
                  reserveBtn={false}
                  messagesBtn={true}
                  setUpdateList={setUpdateList}
                  context="reservation"
                />
              ))}
          </CardGridWrapper>
        </>
      )}
      {confirmedProducts.length === 0 && pendingProducts.length === 0 && (
        <TitleBanner
          color="orange"
          // title={info.t("noReservationAwaitingPayment")}
          subtitle={info.t("noReservationAwaitingPayment")}
        />
      )}
      {/* <Modal
        className="ahp-modal"
        visible={isPaymentVisible}
        onOk={() => setIsPaymentVisible(false)}
        onCancel={() => setIsPaymentVisible(false)}
        footer={null}
        title={null}
        closable={false}
        width="auto"
        style={{ maxWidth: "600px" }}
        bodyStyle={{ padding: "0px" }}
      >
        <Payment
          confirmedProducts={confirmedProducts}
          setIsPaymentVisible={setIsPaymentVisible}
          updateList={updateList}
          setUpdateList={setUpdateList}
          setActiveKey={setActiveKey}
        />
      </Modal> */}
    </div>
  );
}

export default Reservations;
